import React from 'react';
import './WhyTourX.css'

const WhyTourX = () => {
    return (
        <div className="Why-tourx-wrap">
            <div className="whyTourx-container">
                <div className="whyTourx-content">
                        <h5>Why TourX</h5>
                        <h1>Why You Are Travel With  <br /> Tourx</h1>
                </div>

                <div className="box-container">
                    <div className="box">2000+ Our worldwide guide</div>
                    <div className="box">100% trusted travel agency</div>
                    <div className="box">10+ year of travel experience</div>
                    <div className="box">90% of our traveller happy</div>
                </div>
            </div>
        </div>
    );
};

export default WhyTourX;